import PropTypes from "prop-types";
import { Input } from "../../../components/FormComponents";
import ProposalPreview from "../../../components/ProposalPreview";
import { formatCurrency } from "../../../utils/proposalHelpers";

export default function StepReview({
	formData,
	setFormData,
	sections,
	selectedItems,
	companies,
	clients,
	totalValue,
	errors,
}) {
	const selectedCompany = companies.find(
		(c) => String(c.id) === String(formData.company_id),
	);
	const selectedClient = clients.find(
		(c) => String(c.id) === String(formData.client_id),
	);

	return (
		<div className="space-y-6">
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
				<div className="md:col-span-2 bg-slate-900/50 backdrop-blur border border-white/5 rounded-xl p-6">
					<h2 className="text-lg font-semibold text-white mb-4">
						Resumo da Proposta
					</h2>
					<div className="grid grid-cols-2 gap-4 text-sm">
						<div>
							<p className="text-slate-500">Cliente</p>
							<p className="text-white font-medium">
								{selectedClient?.name || "-"}
							</p>
						</div>
						<div>
							<p className="text-slate-500">Empresa emissora</p>
							<p className="text-white font-medium">
								{selectedCompany?.name || "-"}
							</p>
						</div>
						<div>
							<p className="text-slate-500">Validade</p>
							<p className="text-white font-medium">
								{formData.validity_days} dias
							</p>
						</div>
						<div>
							<p className="text-slate-500">Valor Total</p>
							<p className="text-green-400 font-bold text-lg">
								R$ {formatCurrency(totalValue)}
							</p>
						</div>
					</div>
				</div>

				<div className="bg-amber-600/10 border border-amber-500/20 rounded-xl p-6 flex flex-col justify-center">
					<p className="text-amber-300 font-semibold mb-2">Quase pronto!</p>
					<p className="text-xs text-amber-200/70 leading-relaxed mb-4">
						Revise o preview na lateral antes de finalizar. Certifique-se de que
						os valores e termos estao corretos.
					</p>

					<div className="bg-[#0B0F19]/50 p-4 rounded-lg border border-white/5 space-y-3">
						<label className="flex items-center gap-2 cursor-pointer">
							<input
								type="checkbox"
								className="w-4 h-4 rounded border-slate-600 bg-slate-800 text-cyan-500 focus:ring-cyan-500 focus:ring-offset-slate-900"
								checked={formData.acceptance_config?.require_passcode || false}
								onChange={(e) =>
									setFormData({
										...formData,
										acceptance_config: {
											...formData.acceptance_config,
											require_passcode: e.target.checked,
											passcode: e.target.checked
												? formData.acceptance_config?.passcode || ""
												: "",
										},
									})
								}
							/>
							<span className="text-sm text-slate-300">
								Exigir Senha para acessar a Proposta (Passcode)
							</span>
						</label>

						{formData.acceptance_config?.require_passcode && (
							<Input
								label="Senha (Passcode)"
								placeholder="Digite uma senha..."
								value={formData.acceptance_config?.passcode || ""}
								error={errors?.passcode}
								onChange={(e) =>
									setFormData({
										...formData,
										acceptance_config: {
											...formData.acceptance_config,
											passcode: e.target.value,
										},
									})
								}
							/>
						)}
					</div>
				</div>
			</div>

			<div className="bg-[#0B0F19] border border-white/5 rounded-2xl overflow-hidden shadow-2xl">
				<div className="bg-slate-900/50 p-3 border-b border-white/5 flex items-center justify-between">
					<span className="text-xs font-bold text-slate-500 uppercase tracking-widest">
						Visualização Final
					</span>
				</div>
				<div className="max-h-[800px] overflow-y-auto">
					<ProposalPreview
						formData={{
							...formData,
							total_value: totalValue,
						}}
						sections={sections}
						items={selectedItems}
						company={selectedCompany}
					/>
				</div>
			</div>
		</div>
	);
}

StepReview.propTypes = {
	formData: PropTypes.object.isRequired,
	setFormData: PropTypes.func.isRequired,
	sections: PropTypes.array.isRequired,
	selectedItems: PropTypes.array.isRequired,
	companies: PropTypes.array.isRequired,
	clients: PropTypes.array.isRequired,
	totalValue: PropTypes.number.isRequired,
	errors: PropTypes.object,
};
